import { render, staticRenderFns } from "./KvmDockerProxy.vue?vue&type=template&id=72bd6516&scoped=true&"
import script from "./KvmDockerProxy.vue?vue&type=script&lang=js&"
export * from "./KvmDockerProxy.vue?vue&type=script&lang=js&"
import style0 from "./KvmDockerProxy.vue?vue&type=style&index=0&id=72bd6516&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bd6516",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72bd6516')) {
      api.createRecord('72bd6516', component.options)
    } else {
      api.reload('72bd6516', component.options)
    }
    module.hot.accept("./KvmDockerProxy.vue?vue&type=template&id=72bd6516&scoped=true&", function () {
      api.rerender('72bd6516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/kvm/KvmDockerProxy.vue"
export default component.exports